import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';

import Card from 'components/Card/Card.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import GridContainer from 'components/Grid/GridContainer.jsx';
import ViewAllToggle from 'components/ViewAllToggle';
import ActionableSongList from 'components/ActionableSongList';
import config from 'config';
import { displayError } from 'store/actions/errorActions';
import { updateProviderTracks } from 'store/actions/providerTracksActions';
import { getCuratedTracks } from 'services/providerService';

const { defaultListLengthDisplay } = config;

const CuratedForYou = ({
  uid,
  displayError,
  curated,
  favoriteGenres,
  updateProviderTracks,
}) => {
  const listRef = useRef(null);
  const [showAll, setShowAll] = useState(false);

  const listLength = curated && curated.length;

  const showFullCuratedList = () => {
    if (!showAll) {
      listRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
    setShowAll(!showAll);
  };

  useEffect(() => {
    // Do nothing if we already have a curated list
    if (!curated.length) {
      buildCuratedListFromProvider();
    }
  }, []);

  /**
   * Build a curated list of tracks pulled from
   * our PROVIDER and according to the list of
   * FAVORITE GENRES the user selected on signup
   */
  const buildCuratedListFromProvider = async () => {
    try {
      const tracks = await getCuratedTracks(favoriteGenres);
      // Update app state
      updateProviderTracks({ type: 'curated', tracks });
    } catch (error) {
      console.log(error);
      displayError('Could not retrieve the curated list');
    }
  };

  /**
   * Build a curated list of tracks pulled from
   * our DATABASE and according to the list of
   * FAVORITE TRACKS the user selected in the app
   */
  // const buildCuratedListFromDb = async () => {
  //   let list = [];
  //   const nbOfFavoritedSongs = favoriteSongs.length;
  //   // Array of all the favorite song ids
  //   const favoriteSongIds = favoriteSongs.map((e) => e.id);
  //   // Map genre to nb of times they appear in the favorite list
  //   const countByGenre = countBy(favoriteSongs, (e) => e.genre);
  //   // Work out what the new user imprint is
  //   await Promise.all(
  //     Object.keys(countByGenre).map(async (genre) => {
  //       // Get the nb of songs with this genre now in the user's favorite list
  //       const nbOfSongsWithThisGenreInFavorites = countByGenre[genre];
  //       // Work out the ratio of songs with this genre compared to other genres in the user's favorite list
  //       const ratioOfThisGenreInFavorites =
  //         nbOfSongsWithThisGenreInFavorites / nbOfFavoritedSongs;
  //       // Work out the nb of songs with this genre that we now need to include in the user's curated list
  //       const nbOfSongsWithThisGenreNeededInCuratedList = Math.round(
  //         nbOfCuratedSongs * ratioOfThisGenreInFavorites
  //       );
  //       // Work out how many songs in this genre we need to request from the database
  //       const nbOfSongsToRequestFromProvider =
  //         nbOfSongsWithThisGenreInFavorites +
  //         nbOfSongsWithThisGenreNeededInCuratedList;
  //       // Exit if nothing to request
  //       if (nbOfSongsToRequestFromProvider <= 0) return;
  //       // Get songs from this genre from our db
  //       let data = await Store.getTracksWIthGenre(
  //         genre,
  //         nbOfSongsToRequestFromProvider
  //       );
  //       // Discard if already in favorites or if we got enough songs
  //       data = data.filter((e) => !favoriteSongIds.includes(e.id));
  //       data = data.slice(0, nbOfSongsWithThisGenreNeededInCuratedList);
  //       // Add those to the list of curated songs
  //       list = list.concat(data);
  //     })
  //   );
  //   // Update app state
  //   updateProviderTracks({ curated: list });
  // };

  return (
    !!listLength && (
      <div>
        <div
          style={{
            backgroundColor: '#FFFFFF',
            borderRadius: '-20px 10px 30px 10px',
            padding: '10px 0px 20px 0px',
          }}
        >
          <GridContainer>
            <GridItem xs={6}>
              <h4
                style={{
                  fontWeight: '600',
                  margin: '25px 0px 20px 20px',
                  color: '#171055',
                  fontSize: '24px',
                }}
                ref={listRef}
              >
                Curated for you
              </h4>
            </GridItem>
            <GridItem xs={6}>
              <ViewAllToggle
                showAll={showAll}
                setShowAll={showFullCuratedList}
              />
            </GridItem>
          </GridContainer>
        </div>
        <Card
          blue
          style={{
            margin: '-30px 0px 0px 0px',
            borderRadius: '0px',
            boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.25)',
          }}
          paper='true'
        >
          <CardBody paper='true'>
            <GridContainer
              style={{
                margin: '0px 0px 0px 0px',
                width: '90%',
                borderRadius: '10px',
              }}
            >
              <ActionableSongList
                data={curated}
                listType='curated'
                listLength={showAll ? listLength : defaultListLengthDisplay}
              />
            </GridContainer>
          </CardBody>
        </Card>
      </div>
    )
  );
};

CuratedForYou.defaultProps = {
  curated: [],
  favoriteGenres: [],
};

const mapStateToProps = (state) => {
  const { uid } = state.user || {};
  const {curated}  = state.providerTracks || {};
  const { favoriteGenres } = state.user;
  return { uid, favoriteGenres, curated };
};

export default connect(mapStateToProps, { updateProviderTracks, displayError })(
  CuratedForYou
);
